<template>
    <div>
        <vs-tabs class="unique_cstm_tab">
            <vs-tab label="SMS">
                <SMS></SMS>
            </vs-tab>
             <vs-tab label="SMS Log">
                <SMSLOG></SMSLOG>
            </vs-tab>
            <vs-tab v-if="checkViewPermission()" label="SMS Template">
                <SMSTemplate></SMSTemplate>
            </vs-tab>
           
        </vs-tabs>
    </div>
</template>

<script>
import SMS from './SMS.vue'
import SMSTemplate from './SMSTemplate.vue'
import SMSLOG from './SMSLOG.vue'
import { PermissionMiddleware } from '../../../mixins/middleware/PermissionMiddleware'

export default {
  name: 'SMSIndex',
  mixins:[PermissionMiddleware],
  components: {
    SMS,
    SMSTemplate,
    SMSLOG
  },
  data () {
    return {
      schoolAdmin: null
    }
  },
  created () {
    const role_permission = localStorage.getItem('role_permission')
    if (role_permission == 1) {
      this.schoolAdmin = true
    } else {
      this.schoolAdmin = false

      this.getModulePermission('Communication', 'sms')
    }
  }
}
</script>